import React from 'react';

const DISPOSITION_CONFIG = {
  answered: { className: 'ccv2-badge--success', label: 'Atendida' },
  abandoned: { className: 'ccv2-badge--danger', label: 'Abandonada' },
  short_abandon: { className: 'ccv2-badge--muted', label: 'Abandono curto' },
  noanswer: { className: 'ccv2-badge--warn', label: 'Não Atendida' },
  busy: { className: 'ccv2-badge--warn', label: 'Ocupado' },
  failed: { className: 'ccv2-badge--danger', label: 'Falha' },
};

export function getDispositionBadge(disposition) {
  const c = DISPOSITION_CONFIG[disposition] || { className: 'ccv2-badge', label: disposition || '-' };
  return <span className={`ccv2-badge ${c.className}`}>{c.label}</span>;
}
